import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { removeToast } from '@/features/ui/uiSlice';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';

export function Toaster() {
  const dispatch = useAppDispatch();
  const toasts = useAppSelector((state) => state.ui.toasts);

  useEffect(() => {
    toasts.forEach((toast) => {
      const duration = toast.duration || 5000;
      const timer = setTimeout(() => {
        dispatch(removeToast(toast.id));
      }, duration);
      return () => clearTimeout(timer);
    });
  }, [toasts, dispatch]);

  return (
    <ToastProvider>
      {toasts.map((toast) => (
        <Toast key={toast.id} variant={toast.type === 'error' ? 'error' : toast.type === 'success' ? 'success' : toast.type === 'warning' ? 'warning' : 'default'}>
          <div className="text-sm font-medium">{toast.message}</div>
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}







